module.exports = __webpack_public_path__ + "img/icon-brand-recognition.1922b68a.svg";